export const MT_PURCHASE_ORDER_EN = {
  title: 'Modern Trade Purchase Order Management',
  pageName: 'Modern Trade Purchase Order',
  titleDetail: 'Modern Trade Purchase Order Detail',
  all: 'All',
  created: 'Created',
  canceled: 'Canceled',
  waiting_finance: 'Waiting Finance',
  waiting_inbound: 'Waiting Inbound',
  inbounded: 'Inbounded',
  full_paid: 'Paid',
  mtNumber: 'MTPO Number',
  createMT: 'Create Modern Trade Purchase Order',
  barCode: 'Barcode',
  packingSpec: 'Packing Spec',
  retailPrice: 'Retail Price (Excl. VAT)',
  poPrice: 'PO Price (Excl. VAT)',
  orderQuantity: 'Order Quantity (PCS)',
  promotionPrice: 'Promotion Price (Excl. VAT)',
  poPriceVAT: 'PO Price (VAT)',
  grossWeight: 'Gross Weight (kg)',
  netValue: 'Net Value (Excl. VAT)',
  netPOValue: 'Net PO Value (Excl. VAT)',
  netPOValueVAT: 'Net PO Value (VAT)',
  netPOValue2: 'Net PO Value',
  promotionDiscount: 'Promotion Discount',
  warningCancel: 'Are you sure you want to cancel this order?',
}
